import { createContext, useState } from "react";

export const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(false);

  return (
    <NavigationContext.Provider value={{ refreshTrigger, setRefreshTrigger }}>
      {children}
    </NavigationContext.Provider>
  );
};
